import { ref } from "valtio";
import { mapStore } from "../store";

export function updateGoogleMap(googleMap: google.maps.Map) {
  mapStore.googleMap = ref(googleMap);
}
